import { render, staticRenderFns } from "./BuilderSidebar.vue?vue&type=template&id=7b7eae50"
import script from "./BuilderSidebar.vue?vue&type=script&lang=js"
export * from "./BuilderSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports